import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ListOfValuesMasterService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdListOfValuesMaster(listOfValuesMasterId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'ListOfValuesMaster/deleteListOfValuesMaster', {'listOfValuesMasterId': listOfValuesMasterId},
            this.httpOptions
        ).pipe(retry(3), catchError(Constant.handleError));
    }

    countListOfValuesMaster(listOfValuesMaster): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'ListOfValuesMaster/count', {'listOfValuesMaster': listOfValuesMaster},
                                            this.httpOptions
        ).pipe(retry(3), catchError(Constant.handleError));
    }

    updateListOfValuesMaster(listOfValuesMaster): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'ListOfValuesMaster/updateListOfValuesMaster', [listOfValuesMaster], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addListOfValuesMaster(listOfValuesMaster): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'ListOfValuesMaster/addListOfValuesMaster', [listOfValuesMaster], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllListOfValuesMaster(listOfValuesMaster, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'ListOfValuesMaster/findAllListOfValuesMaster',
            {'listOfValuesMaster': listOfValuesMaster, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
